const panelMixin = {
    data () {
        return {
            panelMixin_isUserMrt: $store.getters['user-state/isUserMrt'],
            panelMixin_isUserCustomer: $store.getters['user-state/isUserCustomer'],
            panelMixin_isUserReseller: $store.getters['user-state/isUserReseller'],
            panelMixin_isUserCustomerOrReseller: $store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller'],
            panelMixin_isUserGenerateLive: $store.getters['user-state/isUserGenerateLive'],
            panelMixin_isUserAdminGL: $store.getters['user-state/isUserAdminGL'],
        }
    },
    methods: {
        panelMixin_getUserSettingServerIP () {
            let api = {
                verb: params.verb,
                service: moduleAjaxService,
                url: baseUrl + '/topDestination/' + params.destinationId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        panelMixin_setTopDestination(params, callFunc = null) {
            let dispatch = 'voip-destination-api/setTopDestination'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-destinations-api/setTopDestination'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getTopDestinations(params, callFunc = null) {
            let dispatch = 'voip-destination-api/getTopDestination'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-destinations-api/getTopDestination'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorDestinations(params, callFunc = null) {
            let dispatch = 'voip-vendor-api/dropDownDestinationsList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/dropDownDestinationsList'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorDivisionByName(params, callFunc = null) {
            let dispatch = 'voip-vendor-api/getVendorDivisionByName'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/getVendorDivisionByName'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_createVendorDestinationStatus(params, callFunc = null) {
            let dispatch = 'voip-vendor-destination-status-api/create'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-vendor-destination-status-api/mrtCreate'
            }

            $store.dispatch(dispatch, params, {root: true}).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getBroadcastHistory(params, callFunc = null) {
            let dispatch = 'voip-testing-panel-api/getBroadcastHistory'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-testing-panel-api/getMrtBroadcastHistory'
            }
            $store.dispatch(dispatch, params).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getUserVoipDivision(propName, callFunc = null) {
            let dispatch = 'voip-rate-division-api/getDropDownList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-rate-division-api/getDropDownList'
            }
            if (this.panelMixin_isUserGenerateLive || this.panelMixin_isUserAdminGL) {
                return []
            }
            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getUserVoipLcrDivision(propName, callFunc = null) {
            let dispatch = 'voip-rate-division-api/getDropDownLcrList'
            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorsDropdownByDivision(propName, params, callFunc = null) {
            let dispatch = 'voip-vendor-api/getDropDownList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/getDropDownList'
            }
            $store.dispatch(dispatch, params).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getVendorsDropdown(propName, callFunc = null) {
            let dispatch = 'voip-vendor-api/getDropDownList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-vendor-api/getDropDownList'
            }
            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getDestinations(propName, callFunc = null) {
            let dispatch = 'voip-destination-api/getDropDownList'
            if (this.panelMixin_isUserMrt) {
                dispatch = 'voip-mrt-destinations-api/getDropDownList'
            }
            $store.dispatch(dispatch).then( (r) => {
                this[propName] = r
                if (callFunc) callFunc(r)
            })
        },
        panelMixin_getDestinationRate(params, callFunc = null) {
            let dispatch = 'voip-destination-api/getDestinationRate'
            if (this.panelMixin_isUserCustomerOrReseller) {
                dispatch = 'voip-destination-api/getDestinationRateByDialCode'
            }
            $store.dispatch(dispatch, params).then( (r) => {
                if (callFunc) callFunc(r)
            })
        },
    }
};

export default panelMixin
